<template lang="pug">
  div.lmm-content-body-padded
    b-container.d-flex.justify-content-between.mb-2(fluid, v-if="!AppState.isStandalone")
      b-button(variant="link", size="sm", style="max-width: 100%", target="_blank", href="https://linkmemine.co.kr/faq/p/agent_guide.php")
        span {{$t('tutorial-download')}}
    b-container(fluid, v-if="AppState.isStandalone")
      b-card-group(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            span {{$t('windows')}}
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}}
              b-button(@click='openInstallerModal') {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_agent_manual_windows_kr.pdf`)") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manager}/linkmemine_windows_manager_setup.exe`)", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_admin_manual_pc_cs_kr.pdf`)") {{$t('download')}}
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            span {{$t('android')}}
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="AppState.mobile.Android", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_admin_manual_android_kr.pdf`)") {{$t('download')}}
    // @@@ 서비스에서 다운로드 관련 항목
    b-container(fluid, v-else)
      b-card-group(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/windows", scale="2")
            span Windows
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center
              div.text-nowrap {{$t('agent')}}
              div.d-flex.flex-wrap.agent-button-container
                b-button.agent_download_button(size="sm", @click='openInstallerModal') {{$t('auto_install_multiple')}}
                b-button.agent_download_button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${agent}/linkmemine_windows_agent_setup.exe`)", download) {{$t('single_agent_install')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_agent_manual_windows_kr.pdf`)") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manager}/linkmemine_windows_manager_setup.exe`)", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_admin_manual_pc_cs_kr.pdf`)") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('system-checker')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl('https://admin.linkmemine.com/download/tools/LinkMeMine_Checker.exe')") {{$t('download')}}
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/apple", scale="2")
            span MacOS
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center(style="border-bottom: 1px solid rgba(0, 0, 0, 0.125); border-radius: 0") {{$t('agent')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${agent}/linkmemine_mac_agent_setup.zip`)", download) {{$t('download')}}
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/android", scale="2")
            span Android
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl('https://play.google.com/store/apps/details?id=com.linkmemine.manager')") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_admin_manual_android_kr.pdf`)") {{$t('download')}}
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="mobile", scale="2")
            span {{$t('ios')}}
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('program')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl('https://apps.apple.com/kr/app/linkmemine-manager/id1291160549')") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/linkmemine_admin_manual_ios_kr.pdf`") {{$t('download')}}
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="regular/file", scale="1.4")
            span ETC
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('web')}} {{$t('manager')}} {{$t('manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_admin_manual_pc_kr.pdf`)") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('proposal')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_proposal_kr.pdf`)") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('brochure')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${manual}/linkmemine_brochure_kr.pdf`)") {{$t('download')}}
    agent-installer-dialog(@confirmed="handleInstallerResult")
</template>

<script>
import {getCurrentLanguage} from '@/i18n'
import AgentInstallerDialog from './components/AgentInstallerDialog.vue'
import Appstate from '@/plugins/appstate'
import CryptoJS from 'crypto-js'

const AES_KEY = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_SECRET_KEY)
const AES_IV = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_IV)

export default {
  name: 'downloads-component',
  components: {AgentInstallerDialog},
  methods: {
    openInstallerModal() {
      this.$root.$emit('bv::show::modal', 'agent-installer-dialog')
    },
    handleInstallerResult(data) {
      const type = data.installType === 'autoInstall' ? 'on' : 'off'
      const formattedExpireDate = data.expireDate.split('-').join('')
      const proxyServer = data.proxyServer || '0'
      const proxyPort = data.proxyPort || '0'
      const proxyId = data.proxyId
      const proxyPassword = data.proxyPassword
      const port = '443'
      
      let strData = `${type};${Appstate.Path.origin};${port};${data.id};${data.password};${formattedExpireDate};${proxyServer};${proxyPort}`

      if (proxyId && proxyPassword) {
        strData += `;${proxyId};${proxyPassword}`
      }

      const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(strData), AES_KEY,
          { iv: AES_IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      )
      const encoded = encrypted.ciphertext.toString(CryptoJS.enc.Base64)
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/g, '')
      const baseFilename = `${encoded}.exe`
      const originalUrl = `${this.agent}/linkmemine_windows_agent_auto_setup.exe`
      const downloadUrl = this.generateUrl(originalUrl)
      
      fetch(downloadUrl)
          .then(res => res.blob())
          .then(blob => {
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = baseFilename
            a.click()
            URL.revokeObjectURL(a.href)
          })
          .catch(err => {
            this.$awn.warning(this.$t('file_download_error'))
          })
    },
    generateUrl(baseUrl) {
      return `${baseUrl}?timestamp=${new Date().getTime()}`
    },
  },
  data() {
    let lang = getCurrentLanguage()
    if (lang === 'ko') {
      lang = 'kr'
    }
    return {
      agent: `${this.AppState.Path.download}/agent`,
      manager: `${this.AppState.Path.download}/manager`,
      manual: `${this.AppState.Path.download}/manual/${lang}`,
    }
  },
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
  height: 1.5rem;
  width: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
  
  > svg {
    color: black;
  }
}

.fa-icon {
  position: relative;
  margin-right: 1rem;
  color: #6F6F6F;
}

.download-header span {
  position: relative;
  top: 0.25rem;
}

.agent-button-container {
  gap: 0.5rem;
  justify-content: flex-end;
}

.agent_download_button {
  white-space: nowrap;
  width: auto;
}
</style>